import { render } from "./LogoRekion.vue?vue&type=template&id=98485a24&scoped=true&ts=true"
import script from "./LogoRekion.vue?vue&type=script&lang=ts"
export * from "./LogoRekion.vue?vue&type=script&lang=ts"

import "./LogoRekion.vue?vue&type=style&index=0&id=98485a24&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98485a24"]])

export default __exports__